<div class="modal-header">
  <h4 class="modal-title">Torque Graph</h4>
  <button type="button" class="btn-close btn-close-white" aria-label="Close" (click)="close()"></button>
</div>
<div class="modal-body">
  <p>
    Provide a screenshot of the dyno graph under ECU settings in car settings to extract the torque curve.
    Use the Playstation screenshot tools to capture the image. Do not crop the image.
    For proper processing, use the d-pad to navigate to the ECU settings.
  </p>
  <h4>How to get a screenshot</h4>
  <ol>
    <li>Go to car settings.</li>
    <li>Open the ECU settings in car settings to display the dyno graph.</li>
    <li>Press the "Share" button on the playstation controller.</li>
    <li>In the Playstation Media Library, highlight the screenshot and press the "Options" button.</li>
    <li>Select "Upload to Playstation App".</li>
    <li>Download the screenshot using the PS app on your mobile device.</li>
  </ol>

  <h4>How to select a screenshot</h4>
  <ol>
    <li>In the GT Pro Tune Transmisison Settings, click the "Select Screenshot" <i class="fa-regular fa-solid fa-image"></i> button</li>
    <li>Select the screenshot that contains the dyno graph for the selected car.</li>
  </ol>

  <p>To clear the torque curve data after selecting a screenshot, click the "Cleare Selected Torque Curve Data" <i class="fa-solid fa-times" ></i> button.</p>

  <p>Note: Images are not stored in GT Pro Tune. </p>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="close()">Close</button>
</div>
